import "./confirmation-dialog.scss";
import { html } from "lit";
import ComponentBase from "./component-base";
import * as bootstrap from "bootstrap";

class ConfirmationDialog extends ComponentBase {
  static get tagName() {
    return "confirmation-dialog";
  }

  constructor() {
    super();
    this.resolver = () => {};
    this.rejecter = () => {};
    this.heading = "";
    this.message = "";
    this.confirmBtnText = "";
    this.cancelBtn = true;
  }

  render() {
    return html`
      <!-- Modal -->
      <div
        class="modal"
        id="confirmationModal"
        data-bs-backdrop="static"
        tabindex="-1"
        aria-labelledby="confirmationModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title fs-3" id="confirmationModalLabel">
                ${this.heading}
              </h5>
            </div>
            <div class="modal-body fs-3">${this.message}</div>
            <div class="modal-footer justify-content-between">
              ${this.cancelBtn
                ? html`
                    <button
                      type="button"
                      class="btn btn-secondary btn-lg"
                      @click=${() => {
                        this.Cancel();
                      }}
                    >
                      Annulla
                    </button>
                  `
                : null}
              <button
                type="button"
                class="btn btn-primary btn-lg"
                @click=${() => {
                  this.Confirm();
                }}
              >
                ${this.confirmBtnText}
              </button>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  Cancel() {
    this.dlg.hide();
    this.rejecter();
  }

  Confirm() {
    this.dlg.hide();
    this.resolver();
  }

  connectedCallback() {
    super.connectedCallback();
  }

  firstUpdated() {
    const dlg = this.querySelector("#confirmationModal");
    dlg.addEventListener("hidden.bs.modal", (event) => {
      this.remove();
    });
    this.dlg = new bootstrap.Modal(dlg, {});
    setTimeout(() => {
      this.dlg.show();
    }, 0);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  static async Show({ heading, message, confirmBtnText, cancelBtn }) {
    return new Promise((res, rej) => {
      const dlg = document.createElement(this.tagName);
      dlg.resolver = res;
      dlg.rejecter = rej;
      dlg.heading = heading;
      dlg.message = message;
      dlg.confirmBtnText = confirmBtnText || "Conferma";
      dlg.cancelBtn = typeof cancelBtn === "boolean" ? cancelBtn : true;
      document.body.appendChild(dlg);
    });
  }
}
ConfirmationDialog.Register();
export default ConfirmationDialog;
